import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcRules = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 12C0.447715 12 0 11.5523 0 11C0 10.4477 0.447715 10 1 10H3L6 7L3 4H1C0.45 4 0 3.55245 0 3.00123C0 2.45 0.45 2 1 2H4L8 6L12 2H14V0L18 3.00123L14 6V4H13L10 7L13 10H14V8L18 11L14 14V12H12L8 8L4 12H1Z",
		fill: "#C6CCDA"
	})]
});
const ForwardRef = forwardRef(SvgIcRules);
export default ForwardRef;
